import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/film";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} 蜜桃成熟时3D 电影资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-accent-700">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
            {item.author}
          </span>
        </div>
        <h3 className="mb-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mb-4 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="flex items-center gap-1 text-sm font-medium text-accent-600">
          阅读全文
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}